import React, { ReactNode } from 'react'
import clsx from 'clsx'
import styles from './ColoredTabs.module.sass'
import { AnimatePresence } from 'framer-motion'
import ColoredTab from './ColoredTab'

interface Props<T> {
    className?: string,
    items: T[],
    active: T,
    toKey: (item: T) => string | number,
    render: (item: T) => ReactNode,
    toColor: (item: T) => string,
    onClick?: (item: T) => void,
}

const ColoredTabs = <T extends unknown>(props: Props<T>): JSX.Element => <div className={clsx(props.className, styles.tabs)}>
    <AnimatePresence>
        {
            props.items.map(item => <ColoredTab
                key={props.toKey(item)}
                active={props.toKey(item) == props.toKey(props.active)}
                color={props.toColor(item)}
                onClick={() => props.onClick?.(item)}
            >
                {props.render(item)}
            </ColoredTab>)
        }
    </AnimatePresence>
</div>

export default ColoredTabs